enum CustomReportStatus {
  Running = 'Running',
  Success = 'Success',
  Failed = 'Failed',
  Partial = 'Partial',
}

export default CustomReportStatus;
